import React from 'react'

import { User } from 'core/application/account/loginUser'
import { Permissions } from 'core/application/account/permissions'
import getPerksEligibleEmployeeWizard from 'core/application/employeeSignup/perks/getPerksEligibleEmployeeWizard'
import getPerksEligibleEmployeeWizardState from 'core/application/employeeSignup/perks/getPerksEligibleEmployeeWizardState'
import updatePerksPersonalDetails from 'core/application/employeeSignup/perks/updatePersonalDetails'

import useLoginUser from 'common/hooks/useLoginUser'

import { ROUTE_PATHS } from 'common/routePaths'

import EmployeeSignup from '../../common/EmployeeSignup'
import { NavItemProps } from '../../common/models'
import PersonalDetails, { PersonalDetailsProps } from '../../common/personalDetails'

const PerksEligibleEmployeeSignup: React.FC = () => {
  const [loginUser] = useLoginUser()

  const userIsAllowedToEnterEmployeeSignUpFlow = (user: User): boolean => {
    return user?.permissions.includes(Permissions.AccessEligibleEmployeeSignupWizard)
  }

  return (
    <EmployeeSignup
      signupFlowPath={ROUTE_PATHS.ELIGIBLE_EMPLOYEE_SIGNUP_FLOW}
      isUserAllowedToEnterSignupFlow={userIsAllowedToEnterEmployeeSignUpFlow(loginUser)}
      employeeSignupWizard={() => getPerksEligibleEmployeeWizard()}
      employeeSignupStateApi={() => getPerksEligibleEmployeeWizardState()}
      navItemsMapping={EmployeesNavItemsMapping}
    />
  )
}

enum EligibleEmployeeSignupStep {
  PersonalDetails = 'perks-personal-details',
}

const EmployeesNavItemsMapping: NavItemProps[] = [
  {
    key: EligibleEmployeeSignupStep.PersonalDetails,
    component: PersonalDetails,
    nextButtonTooltip: '',
    mapState: (state: any): PersonalDetailsProps => {
      return {
        personalDetailValues: {
          personalEmail: state?.personalEmail,
          phoneNumber: state?.phoneNumber,
        },
        submitHandler: (values: any) => updatePerksPersonalDetails(values),
        numberOfQuestions: 1,
        currentQuestion: 1,
        next: false,
      }
    },
    icon: 'user',
  },
]

export default PerksEligibleEmployeeSignup
